import {
  useAddAttachmentsMutation,
  useGetAuditTrailQuery,
} from "../../../Services/ticket/Audit-Trail";
import { formatDate } from "../../reusableComponent/DateFormat";
import { Tooltip, IconButton } from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Checkbox from "@mui/material/Checkbox";
import { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import JSZip from "jszip";
import {
  getAttachmentKey,
  sanitizeDownloadFileName,
  forceSaveBlob,
  getAttachmentFileBlob,
} from "../../../utils/attachmentDownload";

interface IProps {
  data: any;
  auditTrailData: any;
  refetchAuditTrail: any;
  refetch: any;
}

type FlatRow = {
  rowKey: string;
  file: any;
  created: string | undefined;
};

const Attachment: React.FC<IProps> = ({
  data,
  auditTrailData,
  refetchAuditTrail,
  refetch,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);
  const { data: TrailData } = useGetAuditTrailQuery({
    id: auditTrailData?.[0]?.id,
    activity: auditTrailData?.[0]?.ticket_activity,
  });

  const attachments = [data];

  const flatRows: FlatRow[] = useMemo(() => {
    const rows: FlatRow[] = [];
    attachments.forEach((attachment, aIdx) => {
      (attachment?.attachments || []).forEach((file: any, fIdx: number) => {
        rows.push({
          rowKey: `${aIdx}-${getAttachmentKey(file, fIdx)}`,
          file,
          created: file?.created,
        });
      });
    });
    return rows;
  }, [data]);

  console.log(flatRows, attachments,"flatRows");

  const attKeys = useMemo(() => flatRows.map((r) => r.rowKey), [flatRows]);

  const selectedSet = useMemo(() => new Set(selectedKeys), [selectedKeys]);
  const selectedAttachmentCount = selectedKeys.length;
  const allAttachmentsSelected =
    attKeys.length > 0 && attKeys.every((k) => selectedSet.has(k));
  const someAttachmentsSelected =
    selectedAttachmentCount > 0 && !allAttachmentsSelected;

  useEffect(() => {
    setSelectedKeys([]);
  }, [data?.id]);

  const [addAttachments] = useAddAttachmentsMutation();

  console.log(data, "data11111111");
  console.log(auditTrailData, "data1111111112222222");

  const toggleAttachmentKey = (key: string) => {
    setSelectedKeys((prev) => {
      const cur = new Set(prev);
      if (cur.has(key)) cur.delete(key);
      else cur.add(key);
      return Array.from(cur);
    });
  };

  const toggleSelectAllAttachments = () => {
    setSelectedKeys((prev) => {
      const cur = new Set(prev);
      const allOn = attKeys.length > 0 && attKeys.every((k) => cur.has(k));
      return allOn ? [] : [...attKeys];
    });
  };

  const downloadSelectedAttachments = async () => {
    const pairs = flatRows.filter(
      (r) => selectedSet.has(r.rowKey) && r.file?.file
    );

    if (pairs.length === 0) {
      toast.error("No downloadable data for the selected attachments.");
      return;
    }

    try {
      const zip = new JSZip();
      const usedNames = new Set<string>();

      for (let i = 0; i < pairs.length; i++) {
        const { file } = pairs[i];
        const baseName = sanitizeDownloadFileName(
          file.file_name || `attachment-${i + 1}`
        );
        let entryName = baseName;
        let dup = 1;
        while (usedNames.has(entryName)) {
          dup += 1;
          const lastDot = baseName.lastIndexOf(".");
          entryName =
            lastDot > 0
              ? `${baseName.slice(0, lastDot)} (${dup})${baseName.slice(lastDot)}`
              : `${baseName} (${dup})`;
        }
        usedNames.add(entryName);

        const blob = await getAttachmentFileBlob(file.file);
        zip.file(entryName, blob);
      }

      const zipBlob = await zip.generateAsync({ type: "blob" });
      const zipBase = sanitizeDownloadFileName(
        data?.ticket_number
          ? `ticket-${data.ticket_number}-attachments`
          : `ticket-${data?.id ?? "attachments"}-attachments`
      );
      forceSaveBlob(zipBlob, `${zipBase}.zip`);
      setSelectedKeys([]);
      toast.success("Attachments saved as a ZIP file.");
    } catch {
      toast.error("Unable to download the attachments.");
    }
  };

  const handleFileChange = async (event) => {
    const newFiles = Array.from(event.target.files);
    const filePromises = newFiles.map((file: any) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          const fileData = {
            file_name: file.name,
            file: e.target.result.split(",")[1], // Extracting Base64 part
          };
          resolve(fileData);
        };
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file);
      });
    });

    try {
      const fileDataArray = await Promise.all(filePromises);

      // Call API to save attachments
      const updatedTicket = {
        ticket_id: data.id,
        attachments: fileDataArray,
      };

      setIsLoading(true);
      const response = await addAttachments(updatedTicket );

      if (response.data) {
        setIsLoading(false);
        toast.success("Attachment added successfully!");
        refetch();
        refetchAuditTrail();
      } else if (response.error) {
        setIsLoading(false);
        toast.error("Error: Something went wrong. Please try again.");
      }
    } catch (error) {
      setIsLoading(false);
      toast.error("An error occurred while uploading files. Please try again.");
    }
  };

  return (
    <div className="table-responsive">

      <div style={{ display: "flex", justifyContent: "end", marginLeft: "auto" }}>
        <Tooltip title="Download">
          <IconButton>
            {selectedAttachmentCount > 0 && (
              <i className="bi bi-download fs-4 text-dark cursor-pointer" onClick={() => downloadSelectedAttachments()}></i>
            )}
          </IconButton>
        </Tooltip>
        <Tooltip
          title="You can add attachments for the following file types: xls, pdf, csv, doc, jpg, png up to a maximum size of 15MB"
          arrow
        >
          <IconButton aria-label="attach file">
            <label htmlFor="attachFileInput">
              <AttachFileIcon style={{ cursor: "pointer" }} />
              <input
                type="file"
                id="attachFileInput"
                className="d-none"
                multiple
                onChange={handleFileChange}
              />
            </label>
          </IconButton>
        </Tooltip>
      </div>
      <table className="table table-row-bordered text-center">
        <thead className="table-light fw-bolder">
          <tr className="bg-primary">
            <th scope="col" >
              {flatRows.length > 0 && (
              <Checkbox
                size="small"
                checked={allAttachmentsSelected}
                indeterminate={someAttachmentsSelected}
                onChange={() => toggleSelectAllAttachments()}
                inputProps={{ "aria-label": "Select all attachments" }}
              />
            )}
            </th>
            <th scope="col">Date</th>
            {/* <th scope="col">Name</th> */}
            <th scope="col">Attachment</th>
            <th scope="col">Preview</th>
          </tr>
        </thead>
        <tbody>
          {flatRows.map((row) => {
            const isChecked = selectedSet.has(row.rowKey);
            return (
              <tr key={row.rowKey}>
                <td>
                  <Checkbox
                    size="small"
                    checked={isChecked}
                    onChange={() => toggleAttachmentKey(row.rowKey)}
                    inputProps={{
                      "aria-label": `Select ${row.file?.file_name || "attachment"}`,
                    }}
                  />
                </td>
                <td>{formatDate(row.created)}</td>
                {/* <td>{TrailData?.[0]?.new_assignee || "N/A"}</td> */}
                <td className="text-primary">{row.file?.file_name}</td>
                <td>
                  <VisibilityIcon
                    className="fs-4 cursor-pointer hover-primary"
                    sx={{
                      color: "#000",
                      transition: "color 0.2s ease",
                      "&:hover": {
                        color: "#6366f1",
                      },
                    }}
                    onClick={() => window.open(row.file?.file, "_blank")}
                  />
                </td>
              </tr>
            );
          })}
          {!flatRows.length && (
            <tr>
              <td colSpan={4}>No attachments found.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Attachment;
